import { ReactElement } from 'react';
import styled from 'styled-components';

interface TabPanelProps {
  label: string;
  children?: ReactElement;
  'data-testid'?: string;
}

export const SubTabPanel = (props: TabPanelProps) => {
  return <PanelContainer>{props.children}</PanelContainer>;
};

export const SubTabPanelType = (
  <SubTabPanel label="">
    <></>
  </SubTabPanel>
).type;

export const SubTabPanelContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-grow: 2;
  background: ${(props) => props.theme.atlas.semantic.color.surface.default};
  border-top: 1px solid
    ${(props) => props.theme.atlas.semantic.color.surface.variant};
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  border-radius: 0 0 8px 8px;
`;

export const SubTabContent = styled.div<{
  active: boolean;
}>`
  display: flex;
  overflow: hidden;
  width: ${(props) => (props.active ? '100%' : '0px')};
  transition: width ease-in 0.3s;
`;

const PanelContainer = styled.div`
  display: flex;
  flex-grow: 2;
  margin: 0 20px 10px 20px;
`;
